export const EVIDENCE_DRAG_TYPE = 'application/x-gmer-billing-evidence';

export const BILLING_EVIDENCE_DRAG_START = 'billing-reconciliation:evidence-drag-start';
export const BILLING_EVIDENCE_DRAG_END = 'billing-reconciliation:evidence-drag-end';

export const hasBillingEvidenceDragType = (dataTransfer = null) => {
  const types = dataTransfer?.types;
  if (!types) return false;
  if (typeof types.includes === 'function') return types.includes(EVIDENCE_DRAG_TYPE);
  if (typeof types.contains === 'function') return types.contains(EVIDENCE_DRAG_TYPE);
  return Array.from(types).includes(EVIDENCE_DRAG_TYPE);
};
